import SearchContainer from './SearchContainer';

/*
* 문제 화면
*/
export default SearchContainer;